import React from "react";
import "./Location.css";

const Location = () => {
  return (
    <section id="location" className="location-section py-5">
      <div className="container">
        {/* Section Header */}
        <div className="location-header text-center mb-5">
          <h2 className="location-title fw-bold">Where We Are Located</h2>
          <p className="location-subtitle">
            Visit our modern office space in the heart of Islamabad
          </p>
        </div>

        <div className="row align-items-center">
          {/* Location Info */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="location-info">
              <div className="office-details">
                <h3 className="office-title fw-bold mb-4">Our Office</h3>

                <div className="address-card">
                  <div className="address-item mb-4">
                    <div className="icon-wrapper">
                      <span className="location-icon">📍</span>
                    </div>
                    <div className="address-content">
                      <h4 className="address-title fw-bold">Address</h4>
                      <p className="address-text mb-0">
                        Teckpik, 3rd Floor Pacific Center
                        <br />
                        F-8 Markaz, Islamabad
                        <br />
                        Pakistan
                      </p>
                    </div>
                  </div>

                  <div className="address-item mb-4">
                    <div className="icon-wrapper">
                      <span className="location-icon">📞</span>
                    </div>
                    <div className="address-content">
                      <h4 className="address-title fw-bold">Phone</h4>
                      <a href="tel:+923170725045" className="address-link">
                        +92-317-0725045
                      </a>
                    </div>
                  </div>

                  <div className="address-item mb-4">
                    <div className="icon-wrapper">
                      <span className="location-icon">✉️</span>
                    </div>
                    <div className="address-content">
                      <h4 className="address-title fw-bold">Email</h4>
                      <a
                        href="mailto:muhammadtalhajavid@gmail.com"
                        className="address-link"
                      >
                        muhammadtalhajavid@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="address-item">
                    <div className="icon-wrapper">
                      <span className="location-icon">🕒</span>
                    </div>
                    <div className="address-content">
                      <h4 className="address-title fw-bold">Business Hours</h4>
                      <p className="address-text mb-0">
                        Monday - Friday: 9:00 AM - 6:00 PM
                        <br />
                        Saturday: 10:00 AM - 2:00 PM
                        <br />
                        Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>

                <div className="location-features mt-4">
                  <h5 className="features-title fw-bold mb-3">
                    Office Features
                  </h5>
                  <div className="features-list">
                    {/* <span className="feature-badge">Modern Workspace</span> */}
                    {/* <span className="feature-badge">Meeting Rooms</span> */}
                    <span className="feature-badge">High-Speed Internet</span>
                    <span className="feature-badge">Parking Available</span>
                    {/* <span className="feature-badge">Security</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Google Maps Embed */}
          <div className="col-lg-6">
            <div className="map-container">
              <div className="map-wrapper">
                <iframe
                  src="https://maps.google.com/maps?width=600&height=400&hl=en&q=teckpik%20pacific%20center&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                  width="100%"
                  height="450"
                  style={{ border: 0, borderRadius: "15px" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Teckpik Office Location"
                  className="google-map"
                ></iframe>
              </div>

              {/* Directions Button */}
              <div className="directions-section text-center mt-4">
                <a
                  href="https://www.google.com/maps/dir//Teckpik,+3rd+Floor+Pacific+Center,+F-8+Markaz,+Islamabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn directions-btn"
                >
                  Get Directions
                </a>
                <p className="directions-text mt-2 small">
                  Click above for turn-by-turn navigation to our office
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
